import { NotificationManager } from "react-notifications";

function convert_to_english_number(str) {
  const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];
  str = str.toString();
  for (var i = 0; i < 10; i++) {
    str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
  }
  str = str.replace(/[^0-9.]/g, "").replace(/ /g, "");
  return str;
}
export function priceNumbers(number) {
  let value = convert_to_english_number(String(number));
  value = Number(value).toLocaleString('en');
  return value;
}
export function checkMinMax(value = 0, min = 0, max = 0) {
  if (value < min || value > max) {
    return false;
  }
  if (value >= min && value <= max) {
    return true;
  }
}
export function htmlToJpg(elements) {
  let main = "data:image/svg+xml,";
  let parent = `<svg xmlns='http://www.w3.org/2000/svg'><foreignObject width='100%' height='100%'><div xmlns='http://www.w3.org/1999/xhtml' style='width: fit-content;margin:10px auto;border:1px solid black;padding:20px;'><style>svg {width: 100%;height: 100%;background-color:white;} div {  direction: rtl;}table tr td{  border-left: 50px solid transparent;  border-bottom: 1px solid black;  padding:5px 0;}</style>${elements}</div></foreignObject></svg>`;
  return main + encodeURIComponent(parent);
}
export function notification({ text = '', title = '', duration = 5000, type = 'error', onClick = () => { } }) {
  NotificationManager[type](text, title, duration, onClick);
}
export function setTitle(title=''){
  document.title = title
}